<template>
	<div class="view-campaign">
		<!-- Loading state -->
		<Loading v-if="!campaign && !status" />
		<!-- Has campaign -->
		<template v-else-if="status === 200">
			<Campaign :campaign="campaign" class="campaign" :hide="['view']" />
			<Submissions :campaign="campaign" />
		</template>
		<!-- Error state -->
		<Card v-else>
			<h2>Something went wrong, please try again.</h2>
		</Card>
	</div>
</template>

<script>
import { mapActions } from 'vuex'
import toast from '@/mixins/toast'
import Card from '@/components/shared/Card'
import Loading from '@/components/shared/Loading'
import Campaign from '@/components/admin/Campaign'
import Submissions from '@/components/admin/Submissions'

export default {
	name: 'view-campaign',
	data() {
		return {
			campaign: null,
			status: 0
		}
	},
	computed: {
		id() {
			return this.$route.params.id
		}
	},
	methods: {
		...mapActions('api', ['get'])
	},
	async created() {
		// Reset error
		this.status = 0
		// Load active campaign
		try {
			const endpoint = `/campaigns/${this.id}`
			const res = await this.get({ endpoint })
			this.campaign = await res.json()
			this.status = res.status
		} catch (err) {
			const status = err.status || 500
			if (status === 404) {
				this.toastErr(`Campaign with ID ${this.id} not found.`)
				this.$router.replace('/admin/manage')
			} else {
				this.status = status
			}
		}
	},
	mixins: [toast],
	components: {
		Loading,
		Campaign,
		Submissions,
		Card
	}
}
</script>

<style lang="scss" scoped>
.campaign {
	margin-bottom: 3rem;
}
</style>
